/* eslint-disable no-param-reassign */
/* eslint-disable prefer-const */
/* eslint-disable func-names */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */

import { add } from 'date-fns';

/* eslint-disable no-inner-declarations */
export default function _caseStudy() {
    const caseStudyComponents = document.querySelectorAll('.case-study-rsev');
    // Flag to track if quotes are already wrapped
    let quotesWrapped = false;

    function wrapWithQuotes(elements) {
        if (elements) {
            elements.forEach((element) => {
                if (!quotesWrapped) {
                    const originalText = element.textContent;
                    const newText = `“${originalText}”`;
                    element.textContent = newText;
                }
            });
            // Set flag to true after wrapping quotes
            quotesWrapped = true;
        }
    }

    if (caseStudyComponents.length > 0) {
        caseStudyComponents.forEach((component) => {
            const quotes = component.querySelectorAll('h3');
            if (!quotesWrapped) {
                wrapWithQuotes(quotes);
                quotesWrapped = true;
            }
        });

        const head = document.head;

        // Create and append the link element
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href =
            'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        head.appendChild(link);

        // Create and append the script element
        const script = document.createElement('script');
        script.src =
            'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        head.appendChild(script);

        // Additional code to initialize Swiper after script loads
        script.onload = function () {
            caseStudyComponents.forEach((component) => {
                const swiper = new Swiper(component, {
                    slidesPerView: 1.05,
                    centeredSlides: true,
                    spaceBetween: 7,
                    // Navigation arrows
                    navigation: {
                        nextEl: component.querySelector(
                            '.case-study-rsev__control--next'
                        ),
                        prevEl: component.querySelector(
                            '.case-study-rsev__control--prev'
                        ),
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 1,
                        },
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        bulletClass: `swiper-pagination-bullet case-study-rsev__pagination-bullet`,
                        clickable: true,
                    },
                });

                // set width of bullet lines and arrow container dependent on image width
                const getImageWidth = new Promise((res, rej) => {
                    const interval = setInterval(() => {
                        let imageWidth = component.querySelector(
                            '.case-study-rsev__image'
                        ).offsetWidth;

                        if (imageWidth > 0) {
                            clearInterval(interval);
                            res(imageWidth);
                        }
                    }, 300);
                });

                getImageWidth.then((width) => {
                    component.querySelector(
                        '.case-study-rsev__controls-group'
                    ).style.width = `${width}px`;
                });
            });
        };
    }
}

document.addEventListener('DOMContentLoaded', _caseStudy);
